import ProductEdit from "../components/page/ProductEdit";

const ProductEditPage = () => {
  return (
      <ProductEdit />
  );
};
export default ProductEditPage;
